module.exports = __webpack_public_path__ + "img/LinkedIn-black.63d58f66.svg";